<template>
  <div class="cotainer card-item">
    <div class="card-title">
      <div class="title-box">
        <span class="title-text">{{ cardTitle }}</span>
      </div>
      <div class="title-boxs">
        <span class="btn-action-group">
          <a-button
            type="primary"
            @click="addPay"
            class="btn-action"
            v-if="(oldInfos?.id && isRevise) || !isScore"
            >新增</a-button
          >
          <!-- <a-button
            class="btn-action"
            type="primary"
            v-if="oldInfos?.id"
            @click="showevidence"
          >
            佐证材料</a-button
          > -->
          <!-- <a-button
            @click="importsj()"
            class="btn-action"
             v-if="(oldInfos?.id && isRevise) || !isScore"
            >导入</a-button
          > -->
          <a-button
            class="btn-action"
            danger
            type="text"
            @click="batchDelete"
            v-if="(oldInfos?.id && isRevise) || !isScore"
          >
            批量移除</a-button
          >
        </span>
      </div>
    </div>

    <div class="cotainerfottter">
      <a-table
        style="text-align: center"
        :locale="{ emptyText }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        @change="handleTableChange"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
        :scroll="{ y: 320 }"
        :row-selection="rowSelection"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template slot="fileName" slot-scope="text, record">
          <div
            @click="sbs(record)"
            style="
              color: #e5914b;
              cursor: pointer;
              width: 200px;
              overflow: hidden;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin: 0px auto;
            "
            :title="text"
          >
            {{ text }}
          </div>
        </template>
        <!-- <template
            style="width: 100px"
            slot="capitalSource"
            slot-scope="text, record"
          >
            <tr
              v-for="(item, index) in record.lxSubsidyFundCostList"
              :key="index"
              :style="
                index + 1 == record.lxSubsidyFundCostList.length
                  ? ''
                  : 'border-bottom: 1px solid #e8e8e8;'
              "
              class="table-tr"
            >
              <div class="table-content" :title="item.project">
                <span>{{ item.project }}</span>
              </div>
            </tr>
            <span v-if="record.lxSubsidyFundCostList.length == 0">-</span>
          </template> -->
        <!-- <template style="width: 100px" slot="name" slot-scope="text, record">
            <tr
              v-for="(item, index) in record.lxSubsidyFundCostList"
              :key="index"
              :style="
                index + 1 == record.lxSubsidyFundCostList.length
                  ? ''
                  : 'border-bottom: 1px solid #e8e8e8;'
              "
              class="table-tr"
            >
              <div class="table-content" :title="item.amount">
                <span>{{ item.amount }}</span>
              </div>
            </tr>
            <span v-if="record.lxSubsidyFundCostList.length == 0">-</span>
          </template> -->
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 50px"
          v-if="(oldInfos?.id && isRevise) || isScore"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="(oldInfos && oldInfos.id && !isEdit) || isScore"
            @click="showevidence(record)"
          >
            <img class="img-box" src="../../assets/images/imgcl.png" alt="" />
            <span>佐证材料</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="editInfo(record, index)"
            v-if="(oldInfos && oldInfos.id && isRevise) || !isScore"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="deleteInfo(record, index)"
            v-if="(oldInfos && oldInfos.id && isRevise) || !isScore"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
          <!-- <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="(oldInfos && oldInfos.id && isRevise)"
            @click="seeInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>查看</span>
          </div> -->
        </span>
        <!-- <template slot="action" slot-scope="record" style="margin: 0 20px">
            <tr class="table-tr">
              <div
                class="table-content"
                style="
                  justify-content: space-between;
                  padding: 0px 50px;
                  box-sizing: border-box;
                "
              >
                <div
                  class="flex align-items-center"
                  style="cursor: pointer"
                  @click="editInfo(record, index)"
                  v-if="oldInfos?.id && isRevise"
                >
                  <img
                    class="img-box"
                    src="../../assets/images/img42.png"
                    alt=""
                  />
                  <span>编辑</span>
                </div>
                <div
                  class="flex align-items-center"
                  style="cursor: pointer"
                  @click="deleteInfo(record, index)"
                  v-if="oldInfos?.id && isRevise"
                >
                  <img
                    class="img-box"
                    src="../../assets/images/img43.png"
                    alt=""
                  />
                  <span>移除</span>
                </div>
              </div>
            </tr>
          </template> -->
      </a-table>
    </div>
    <!-- 添加编辑 -->
    <AddAnnualPlan
      ref="addAnnualPlan"
      @addAnnualPlan="addAnnualPlanAi"
    ></AddAnnualPlan>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定要移除该年度计划吗?</p>
    </a-modal>
    <data-import ref="dataImport" @refreshData="addAnnualPlan"></data-import>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <evidencelist
          :title="title"
          :isEdit="isEdit"
          :id="id"
          :dataid="sj.id"
          @closePreview="showtable = false"
        >
        </evidencelist>
      </div>
    </div>
    <div class="preview-pop-box" v-if="showiframe">
      <div class="preview-boxs" style="height: 90%">
        <newpreview
          :previewUrl="previewUrl"
          @closePreview="showiframe = false"
          dialogTitle="年度总结报告预览"
        ></newpreview>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";
import evidencelist from "@/components/common/evidencelist";
import foundSource from "./addSource.vue";
import AddAnnualPlan from "./addAnnualPlan.vue";
import newpreview from "@/components/common/newpreviews";

const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "年份",
    dataIndex: "year",
    id: "year",
    align: "center",
    width: 150,
  },
  {
    title: "年度总结报告",
    dataIndex: "fileName",
    id: "fileName",
    align: "center",
    width: 150,
    scopedSlots: { customRender: "fileName" },
  },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 300,
    scopedSlots: { customRender: "action" },
  },
];
export default {
  data() {
    return {
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      isEdit: false,
      selectedRowKeys: [],
      emptyText: "暂无数据",
      showtable: false,
      id: "",
      title: "",
      showiframe: false,
      previewUrl: "",
      sj: {},
      isScore: false,
    };
  },
  props: {
    oldInfos: {
      type: Object,
    },
    cardTitle: {
      type: String,
    },
    isbj: {
      type: Boolean,
      defalt: true,
    },
    isRevise: {
      type: Boolean,
    },
  },
  components: {
    foundSource,
    AddAnnualPlan,
    dataImport,
    evidencelist,
    newpreview,
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        // 其他 row-selection 的配置
      };
    },
  },
  watch: {
    "oldInfos.id": {
      handler(newValue, oldValue) {
        // console.log(newValue, "9999999999999999");
        if (newValue != null) {
          if (
            this.$parent.editInfo &&
            this.$parent.editInfo?.type == "preview"
          ) {
            this.isEdit = true;
          }
          this.emptyText = "暂无数据";
          this.addAnnualPlan();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
    },
    isRevise: {
      handler(newValue, oldValue) {
        // console.log(newValue,'我是')
        this.isEdit = !newValue;
      },
      immediate: true,
    },
  },
  mounted() {
    this.isScore =
      this.$store.state.role === "score-role" ||
      this.$store.state.role === "education-role" ||
      this.$store.state.role === "education-guide-role";
    if (!this.oldInfos?.id) {
      this.emptyText = "填写基本信息之后才能添加内容";
    }
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
    //this.getData();
    this.addAnnualPlan
  },
  methods: {
    sbs(record) {
      if (
        record.fileName != "" &&
        record.fileName != null &&
        record.fileName != "" &&
        record.fileName != null
      ) {
        this.showiframe = true;
        this.previewUrl = record.filePath;
      } else {
        this.$message.warning("年度总结报告暂未上传，请上传后预览");
      }
    },
    showevidence(record) {
      this.title = "年度计划";
      this.id = this.oldInfos.id;
      this.sj = record;
      this.showtable = true;
    },
    importsj() {
      this.$refs.dataImport.init("annualPlan", this.oldInfos, "年度计划");
    },
    addSource() {
      console.log("this.$refs.foundSource", this.$refs.foundSource);
      this.$refs.foundSource.init("add", this.oldInfos);
    },
    addPay() {
      this.$refs.addAnnualPlan.init("add", this.oldInfos);
    },
    seeInfo(row) {
      this.$refs.addAnnualPlan.init("see", row);
    },
    addAnnualPlan() {
      // this.pagination.current = 1;
      this.getData();
    },
    addAnnualPlanAi(sj) {
      console.log("🚀 ~ addAnnualPlanAi ~ sj:", sj);
      console.log(this.oldInfos, "this.oldInfos.annualPlanList");

      if (sj.type == "add") {
        // sj.record.id = sj.record.name + this.oldInfos.annualPlanList.length;
        // this.oldInfos.annualPlanList.push(sj.record);
        this.pagination.current = 1;
        sj.record.id = sj.record.name + this.oldInfos.annualPlanList.length;
        this.oldInfos.annualPlanList.unshift({
          ...sj.record,
          id: sj.record.name + (this.oldInfos.annualPlanList.length + 1),
        });
      } else {
        let index = this.oldInfos.annualPlanList.findIndex(
          (item) => item.id === sj.record.id
        );
        console.log(sj.record.id, this.oldInfos.annualPlanList);
        console.log(index, "index");
        if (index !== -1) {
          // 如果找到相同的 id，替换该对象
          //this.oldInfos.annualPlanList[index] = sj.record;
          this.$set(this.oldInfos.annualPlanList, index, sj.record);
        }
        console.log(
          this.oldInfos.annualPlanList[index],
          "this.oldInfos.annualPlanList[index]"
        );
      }
      sessionStorage.setItem("pp1", JSON.stringify(this.oldInfos));
      this.getData();
    },
    getData() {
      if (this.oldInfos?.id) {
        this.loading = true;
        let data = {
          applyType: 1,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lxbase/lxAnnualPlan/list", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = data;
              this.pagination.total = res.result.total;
            }
          }
          this.loading = false;
        });
      } else {
        if (
          this.oldInfos &&
          this.oldInfos.annualPlanList &&
          this.oldInfos.annualPlanList.length > 0
        ) {
          this.pagination.total = this.oldInfos.annualPlanList.length;
          const startIndex =
            (this.pagination.current - 1) * this.pagination.pageSize;
          const endIndex = startIndex + this.pagination.pageSize;
          // this.dataList = this.oldInfos.annualPlanList.slice(
          //   startIndex,
          //   endIndex
          // );
          let formatList = this.oldInfos.annualPlanList.slice(
            startIndex,
            endIndex
          );
          if (formatList.length == 0 && this.pagination.current > 1) {
            this.pagination.current = this.pagination.current - 1;
            const startIndex =
              (this.pagination.current - 1) * this.pagination.pageSize;
            const endIndex = startIndex + this.pagination.pageSize;
            formatList = this.oldInfos.annualPlanList.slice(
              startIndex,
              endIndex
            );
          }
          this.dataList = formatList;
        } else {
          this.dataList = [];
          this.pagination.total = 0;
          this.pagination.current = 1;
        }
      }
    },
    handleOk() {
      this.$message.success("移除成功");
      this.showDeleteModel = false;
      this.oldInfos.annualPlanList = this.oldInfos.annualPlanList.filter(
        (item) => item.id != this.deteleId
      );
      sessionStorage.setItem("pp1", JSON.stringify(this.oldInfos));
      this.getData();
      // deleteAction("/lxbase/lxAnnualPlan/delete", {
      //   id: this.deteleId,
      //   applyId: this.oldInfos?.id,
      // }).then((res) => {
      //   if (res.code == 200) {
      //     this.$message.success("移除成功");
      //     this.showDeleteModel = false;
      //     this.getData();
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
    },
    deleteInfo(row, index) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row, index) {
      this.$refs.addAnnualPlan.init("edit", row, index);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    option(type) {
      if (type === 1) {
        this.$emit("upStep", this.dataList);
      } else {
        this.$emit("downStep", this.dataList);
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      let applyType = 1;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的年度计划");
      } else {
        let params = {
          ids: this.selectedRowKeys.toString(),
          applyId: this.oldInfos?.id,
        };
        deleteAction("/lxbase/lxAnnualPlan/deleteBatch", params).then((res) => {
          if (res.code == 200) {
            this.$message.success("批量移除成功");
            // this.pagination.current = 1;
            this.getData();
            this.selectedRowKeys = [];
            this.$forceUpdate();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.cotainer {
  .btn-action {
    width: 100px;
    height: 30px;
    border-radius: 6px;
    font-weight: 400;
    cursor: pointer;
    line-height: 30px;
    margin-right: 10px;
    text-align: center;
  }
  .cotainerhead {
    margin: 20px 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .add-btn {
      width: 100px;
      height: 30px;
      background: #2155b5;
      border-radius: 6px;
      font-weight: 400;
      color: #fff;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  color: #fff;
  background: #2155b5;
  line-height: 38px;
  text-align: center;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
}
.big-box {
  width: 253px;
  margin: 50px auto 0px;
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}
.table-content {
  margin: 0 auto;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}
.table-tr {
  width: 100%;
  display: inline-block;
  text-align: center;
  margin: 0 auto;
  // border-bottom: 1px solid #e8e8e8;
}
/deep/.ant-table-tbody > tr > td:nth-child(6),
/deep/.ant-table-tbody > tr > td:nth-child(5) {
  padding: 0 !important;
  // overflow-wrap: break-word;
}
/deep/.ant-table-tbody > tr > td {
  padding: 0 !important;
  height: 60px;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>
